import React from "react";
import {Link} from "react-router-dom";
import question from "@/assets/images/question.svg";
import useFaqSearchHooks from "@/containers/Faq/useFaqSearchHooks";
import {SearchResultsContainer} from "@/components/FaqSearch/SearchResultsContainer";
import {SearchConditionContainer} from "@/components/FaqSearch/SearchConditionContainer";
import {useFaqFont} from "@/utils/useFaqFont";

export default function FaqSearch() {
    const faqHooks = useFaqSearchHooks();
    useFaqFont();
    return (
        <div className="uk-flex uk-flex-column uk-flex-middle">
            <div className="sub-header">
                <p className="uk-text-large uk-text-bold uk-margin-remove">
                    よくある質問
                </p>
            </div>
            <div className="uk-width-3-4 uk-margin-top">
                <div className="uk-flex uk-flex-middle">
                    <img src={question} alt=""/>
                    <p className="uk-text-medium uk-text-bold uk-margin-small-left">
                        よくある質問（FAQ）
                    </p>
                </div>
                <div className="uk-margin-top">
                    <ul className="uk-tab attribute-tab">
                        <li>
                            <Link to="/faq">FAQ TOP</Link>
                        </li>
                        <li className="uk-active">
                            <Link to="#">検索</Link>
                        </li>
                        <div className="right uk-flex">
                            <p>更新日</p>
                            <p className="uk-margin-small-left">{faqHooks.lastModified}</p>
                        </div>
                    </ul>
                </div>

                <div className="uk-margin-large-bottom">
                    <SearchConditionContainer faqHooks={faqHooks}/>
                    <SearchResultsContainer faqHooks={faqHooks}/>
                </div>
            </div>
        </div>
    );
}
